import React, { useState, useEffect } from 'react';
// material
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// models
import { Message, MessageTypes } from '../../../entities/site';
import { MessageTemplate, emptyMessageTemplate, MessageTemplateClients } from '../../../entities/notification';
// components
import TextInput from "../../../components/inputs/TextInput";
import ActionButton from '../../../components/buttons/ActionButton';
import ModalMessage from '../../../components/message/ModalMessage';
import MobilePreview from './MobilePreview';

const phoneBack = process.env.PUBLIC_URL + '/galilaio/phone_back.png';

interface AddTemplateProps {
    open: boolean;
    template?: MessageTemplate;
    onSave(newTemplate: MessageTemplate): void;
    onClose(): void;
}

const AddTemplate: React.FC<AddTemplateProps> = (props) => {
    const classes = useStyles();

    const [name, setName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [message, setMessage] = useState<string>('Example message text');
    const [messageShortlink, setMessageShortlink] = useState<string>('');

    const [errorMessage, setErrorMessage] = useState<Message>({
        message: '',
        messageType: MessageTypes.notification
    });

    const handleDescriptionChange = (value: string) => {
        if (description.length < 140) {
            setDescription(value);
            setMessage(value);
        }
    }

    const checkForm = () => {
        let error = '';
        if (!name) {
            error = 'Name required';
        }
        if (!description) {
            error = 'Description required';
        }
        if (error) {
            setErrorMessage({ message: error, messageType: MessageTypes.error });
            return false;
        }
        return true;
    }

    const handleSave = () => {
        const newMessageTemplate: MessageTemplate = emptyMessageTemplate;
        newMessageTemplate.client = MessageTemplateClients.galilaio;
        newMessageTemplate.name = name;
        newMessageTemplate.description = description;
        props.onSave(newMessageTemplate);
    }

    useEffect(() => {
        if (props.template) {
            setName(props.template.name);
            setDescription(props.template.description);
            setMessage(props.template.description);
        }
    }, [props.template]);

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth={"sm"}
            classes={{ paper: classes.dialogPaper }}
        >

            <DialogTitle classes={{ root: classes.dialogTitle }} disableTypography>
                New Template
            </DialogTitle>
            <DialogContent>
                {errorMessage.message !== '' && (
                    <ModalMessage message={errorMessage} />
                )}
                <Grid container spacing={2} className={classes.body}>
                    <Grid item xs={6}>
                        <TextInput
                            title="Template Name"
                            type="string"
                            placeholder=""
                            result={name}
                            onChange={(event: any) => setName(event.target.value)}
                        />
                        <div className={classes.descriptionContainer}>
                            <div className={classes.descriptionCounter}>{`${description.length}/140`}</div>
                            <TextInput
                                title="Message"
                                type="string"
                                placeholder=""
                                result={description}
                                onChange={(event: any) => handleDescriptionChange(event.target.value)}
                                multiline
                            />
                        </div>
                        <div className={classes.placeContainer}>
                            <div className={classes.placeTitle}>Placeholders</div>
                            <div><strong>%contact_first_name%</strong> - contact first name</div>
                            <div><strong>%contact_last_name%</strong> - contact last name</div>
                            <div><strong>%street_address%</strong> - contact street address</div>
                            <div><strong>%ref_id%</strong> - reference ID</div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <MobilePreview
                            message={message}
                            messageShortlink={messageShortlink}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ActionButton name="Save" onClick={handleSave} fullWidth size="sm" />
            </DialogActions>
        </Dialog>
    );

}

export default AddTemplate;

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minHeight: 500,
        minWidth: 700
    },
    dialogTitle: {
        fontSize: 18,
        color: "#333333",
        fontFamily: "Roboto",
    },
    body: {
        paddingBottom: 20
    },
    descriptionContainer: {
        position: 'relative'
    },
    descriptionCounter: {
        position: 'absolute',
        top: 0,
        right: 0,
        fontSize: 11
    },
    placeContainer: {
        fontSize: 11,
        paddingBottom: 10
    },
    placeTitle: {
        color: '#627995',
        fontSize: 17,
        textAlign: 'left',
        marginBottom: 10
    }
}));


// WEBPACK FOOTER //
// ./src/pages/campaign/components/AddTemplate.tsx